
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Alert, Button, Col, Descriptions, Divider, message, Row, Space, Tag, Typography } from 'antd'
import { FunctionComponent, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Vector } from '../../assets/svg/Index'
import { OrderBindingModel } from '../../bindings/OrderBindingModel'
import { 결제동의Modal } from '../../components/modal/결제동의Modal'
import { 담당자정보입력Modal } from '../../components/modal/담당자정보입력Modal'
import { 지정상품입력Modal } from '../../components/modal/지정상품입력Modal'
import { 추천코드정보입력Modal } from '../../components/modal/추천코드정보입력Modal'
import { 출원자정보입력Modal } from '../../components/modal/출원자정보입력Modal'
import { 환불정책Modal } from '../../components/modal/환불정책Modal'
import { CategoryModel } from '../../models/CategoryModel'
import { ImageModel } from '../../models/ImageModel'
import { OrderModel } from '../../models/OrderModel'
import { TrademarkModel } from '../../models/TrademarkModel'
import { CategoryService } from '../../services/CategoryService'
import { OrderService } from '../../services/OrderService'
import { Color } from '../../styles/Color'
import { MenuType } from '../../types/MenuType'
import { NavigationType } from '../../types/NavigationType'
import { 출원방법타입 } from '../../types/출원방법타입'
import LocalStorageUtility from '../../utils/LocalStorageUtility'
import NumberUtility from '../../utils/NumberUtility'
import { Container } from '../layout/Container'
import { LayoutContainer } from '../layout/LayoutContainer'
import { 상표결제Item } from './상표결제Item'

export const 상표결제: FunctionComponent = () => {
    const location = useLocation()
    const { id } = useParams()

    const { state } = location

    if (!state && !id) {
        window.location.href = '/'
    }

    const { type, name, alphabet, description, codes, categories, attachment } = state as {
        type: 출원방법타입.출원방법,
        name: string,
        alphabet?: string,
        description: string,
        codes: Array<string>,
        categories: Array<CategoryModel.ITrademarkCategoryFlattenModel>
        attachment?: ImageModel.IAttachmentImageModel | undefined
    }

    const [show담당자정보입력Modal, setShow담당자정보입력Modal] = useState(false)
    const [show출원자정보입력Modal, setShow출원자정보입력Modal] = useState(false)
    const [show추천코드정보입력Modal, setShow추천코드정보입력Modal] = useState(false)
    const [show지정상품입력Modal, setShow지정상품입력Modal] = useState(false)
    const [show결제동의Modal, setShow결제동의Modal] = useState(false)
    const [show환불정책Modal, setShow환불정책Modal] = useState(false)

    const [isLoading, setLoading] = useState(false)
    const [hasAgree, setHasAgree] = useState<boolean>(false)
    const [image, setImage] = useState<ImageModel.IStampImageModel>()
    const [담당자, set담당자] = useState<TrademarkModel.ITrademarkModel담당자Model>()
    const [출원인, set출원인] = useState<TrademarkModel.ITrademarkModel출원인Model>()
    const [추천코드, set추천코드] = useState<string>()
    const [지정상품, set지정상품] = useState<Array<TrademarkModel.ITrademarkModel지정상품Model>>()

    const [items, setItems] = useState<Array<TrademarkModel.ITrademarkPaymentItemModel>>(codes.map((c) => {
        return {
            classificationCode: c,
            commissionType: type,
            isQuick: false,
        }
    }))
    const [v2Categories, setV2Categories] = useState<Array<CategoryModel.ITrademarkCategoryV12Model>>([])

    const getV12 = async () => {
        setLoading(true)
        const response = await CategoryService.v12(codes)
        if (response.status === 200) {
            setV2Categories(response.data)
        }
        setLoading(false)
    }

    const handleOrder = async () => {
        setLoading(true)

        const model: OrderBindingModel.ICreateOrderBindingModel = {
            operator: 담당자!,
            applicant: 출원인!,
            koreanTrademarkName: name,
            englishTrademarkName: alphabet,
            description: description,
            stampId: image?.stampId!,
            items: items.map((i) => {
                return {
                    classificationCode: i.classificationCode,
                    commissionType: i.commissionType,
                    isQuick: i.isQuick
                }
            }),
            attachment: attachment,
            productCategories: categories,
            goodsServices: 지정상품 ?? [],
            recommendation: 추천코드,
        }

        const response = await OrderService.create(model)
        if (response.status === 200) {
            const orderId = response.data.orderId
            LocalStorageUtility.set(orderId, {
                ...model,
                type: type,
                codes: codes,
                stamp: image
            } as OrderModel.IOrderBackupModel)

            setTimeout(() => {
                const totalPrice = Math.round(수수료() * 1.1)

                const isProduction = process.env.NODE_ENV === 'production'
                const successUrl = isProduction ? `https://markerslab.app/payment/success/${orderId}?price=${totalPrice}` : `http://localhost:3000/payment/success/${orderId}?price=${totalPrice}`
                const failUrl = isProduction ? `https://markerslab.app/payment/fail/${orderId}` : `http://localhost:3000/payment/fail/${orderId}`

                window.location.href = `https://payment.markerslab.app/?orderid=${orderId}&successRedirectUrl=${encodeURIComponent(successUrl)}&failureRedirectUrl=${encodeURIComponent(failUrl)}`
            }, 1000)
        }
        setLoading(false)
    }

    const 관납료 = () => {
        const count = items.filter(i => !i.isQuick).length ?? 0
        const quickCount = items.filter(i => i.isQuick).length ?? 0

        const 일반심사_관납료 = 46000 * count
        const 우선심사_관납료 = (160000 + 46000) * quickCount

        return Math.round(일반심사_관납료 + 우선심사_관납료)
    }

    const 특허사무소수수료 = () => {
        const count = items.filter(i => !i.isQuick).length ?? 0
        const quickCount = items.filter(i => i.isQuick).length ?? 0

        switch (type) {
            case 출원방법타입.출원방법.바로출원:
                return 145000 * quickCount
            case 출원방법타입.출원방법.간편출원:
                return (175000 * quickCount) + (30000 * count)
            case 출원방법타입.출원방법.심화출원:
                return (215000 * quickCount) + (70000 * count)
            default:
                return 0
        }
    }

    const 수수료 = () => {
        let price = 18000
        const count = items.length ?? 0
        // const quickCount = items.filter(i => i.isQuick).length ?? 0

        // switch (type) {
        //     case 출원방법타입.출원방법.바로출원:
        //         price = 18000
        //         break
        //     case 출원방법타입.출원방법.간편출원:
        //         price = 48000
        //         break
        //     case 출원방법타입.출원방법.심화출원:
        //         price = 88000
        //         break
        // }

        // const 일반심사_나혼자상표_수수료 = price * count
        // const 우선심사_나혼자상표_수수료 = (145000 + price) * quickCount

        // return Math.round(일반심사_나혼자상표_수수료 + 우선심사_나혼자상표_수수료)
        return price * count
    }

    useEffect(() => {
        const userData = LocalStorageUtility.get('user')
        if (!userData) {
            alert('로그인 후 진행해주세요.')
            window.location.href = '/login'
        }

        if (id) {
            const orderData = LocalStorageUtility.get(id)
            if (orderData) {
                const order = JSON.parse(orderData) as OrderModel.IOrderBackupModel

                set담당자(order?.operator)
                set출원인(order?.applicant)
                if (order.stamp) {
                    setImage(order.stamp)
                }
            }
        }

        getV12()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container type={NavigationType.White} menu={MenuType.상표등록}>
            <Row className="payment-trademark-container">
                <Col span={24}>
                    <LayoutContainer style={{ gap: 20, }}>
                        <Col span={24}>
                            <Space direction="vertical">
                                <Typography.Text
                                    strong
                                    style={{
                                        fontSize: 20,
                                    }}
                                >
                                    {`${name} ${alphabet ? `(${alphabet})` : ''}`}
                                </Typography.Text>
                                <Space size={1}>
                                    {codes.map((c, idx: number) => {
                                        return (
                                            <Typography.Text
                                                key={idx}
                                                style={{
                                                    fontSize: 18,
                                                }}
                                            >
                                                {`${c}류${idx === (codes.length - 1) ? '' : ', '}`}
                                            </Typography.Text>
                                        )
                                    })}
                                </Space>
                            </Space>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 30, }}>
                        <Col span={24}>
                            <Row gutter={[0, 10]}>
                                <Col span={24}>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 20,
                                        }}
                                    >
                                        {`[필수] 담당자 정보`}
                                    </Typography.Text>
                                </Col>
                                {!담당자 && (
                                    <Col span={12}>
                                        <Button
                                            block
                                            className='secondary'
                                            onClick={() => { setShow담당자정보입력Modal(true) }}
                                        >
                                            담당자 정보 입력
                                        </Button>
                                    </Col>
                                )}
                                {담당자 && (
                                    <Col span={24}>
                                        <Typography.Link
                                            onClick={() => { setShow담당자정보입력Modal(true) }}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'담당자 이름'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {담당자?.fullName}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'담당자 이메일'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {담당자?.email}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'담당자 휴대전화'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {담당자?.phoneNumber}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'담당자 유선전화'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {담당자?.telephoneNumber}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Typography.Link>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[0, 20]}>
                                <Col span={24}>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 20,
                                        }}
                                    >
                                        {`[필수] 출원인 정보`}
                                    </Typography.Text>
                                </Col>
                                {!출원인 && (
                                    <Col span={12}>
                                        <Button
                                            block
                                            className='secondary'
                                            onClick={() => { setShow출원자정보입력Modal(true) }}
                                        >
                                            출원인 정보 입력
                                        </Button>
                                    </Col>
                                )}
                                {출원인 && (
                                    <Col span={24}>
                                        <Typography.Link
                                            onClick={() => { setShow출원자정보입력Modal(true) }}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'출원인 이름(한글)'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {출원인.koreanFullName}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'출원인 이름(영문)'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {출원인.englishFullName}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'출원인 특허고객번호'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {출원인.applicantCode}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'출원인 이메일'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {출원인.email}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'출원인 휴대전화'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {출원인.phoneNumber}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Typography.Link>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                        {type === 출원방법타입.출원방법.바로출원 && (
                            <Col span={24}>
                                <Row gutter={[0, 20]}>
                                    <Col span={24}>
                                        <Typography.Text
                                            strong
                                            style={{
                                                fontSize: 20,
                                            }}
                                        >
                                            {`[필수] 지정상품`}
                                        </Typography.Text>
                                    </Col>
                                    <Col span={12}>
                                        <Button
                                            block
                                            className='secondary'
                                            onClick={() => { setShow지정상품입력Modal(true) }}
                                        >
                                            지정상품 입력
                                        </Button>
                                    </Col>
                                    {(지정상품?.length ?? 0) > 0 && (
                                        <Col span={24}>
                                            {지정상품 && (
                                                <Typography.Text type='danger'>{'※ 입력하신 지정상품 중 불명확한 지정상품이 있을경우, 거절 이유가 발생할 수 있습니다.'}</Typography.Text>
                                            )}
                                            <Row gutter={[12, 12]} style={{ marginTop: 12, }}>
                                                {지정상품?.map((s, idx) => {
                                                    return (
                                                        <Col key={idx} span={24}>
                                                            <Descriptions
                                                                bordered
                                                                column={1}
                                                                size="small"
                                                                labelStyle={{ width: 100, }}
                                                            >
                                                                <Descriptions.Item label={'상품류'}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography.Text>{s.classificationCode}</Typography.Text>
                                                                        <Button
                                                                            danger
                                                                            ghost
                                                                            size="small"
                                                                            onClick={() => {
                                                                                set지정상품([...지정상품.filter(i => i !== s)])
                                                                            }}
                                                                        >
                                                                            해제
                                                                        </Button>
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label={'명칭(한글)'}>{s.koreanText}</Descriptions.Item>
                                                                <Descriptions.Item label={'명칭(영문)'}>{s.englishText}</Descriptions.Item>
                                                                <Descriptions.Item label={'유사군'}>
                                                                    <Space size={2} wrap>
                                                                        {s.similarCodes?.split(',')?.map((sc) => {
                                                                            return (
                                                                                <Tag key={sc}>{sc}</Tag>
                                                                            )
                                                                        })}
                                                                    </Space>
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        )}
                        <Col span={24}>
                            <Row gutter={[0, 20]}>
                                <Col span={24}>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 20,
                                        }}
                                    >
                                        {`[선택] 추천코드`}
                                    </Typography.Text>
                                </Col>
                                {!추천코드 && (
                                    <Col span={12}>
                                        <Button
                                            block
                                            className='secondary'
                                            onClick={() => { setShow추천코드정보입력Modal(true) }}
                                        >
                                            추천코드 정보 입력
                                        </Button>
                                    </Col>
                                )}
                                {추천코드 && (
                                    <Col span={24}>
                                        <Typography.Link
                                            onClick={() => { setShow추천코드정보입력Modal(true) }}
                                        >
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={'space-between'}>
                                                        <Col>
                                                            <Typography.Text
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {'추천코드'}
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col>
                                                            <Typography.Text
                                                                strong
                                                                style={{ fontSize: 18 }}
                                                            >
                                                                {추천코드}
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Typography.Link>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 20, justifyContent: 'center', }}>
                        <Col span={24}>
                            <Typography.Text
                                strong
                                style={{
                                    fontSize: 22,
                                }}
                            >
                                {`출원 방법 선택`}
                            </Typography.Text>
                        </Col>
                        {codes.map((c) => {
                            const isActivated = items.some(i => i.classificationCode === c)
                            const isSwitchActivated = items.some(i => i.classificationCode === c && i.isQuick)
                            const v2 = v2Categories.find(v => v.classificationCode === c)

                            return (
                                // eslint-disable-next-line react/jsx-pascal-case
                                <상표결제Item
                                    key={c}
                                    code={c}
                                    type={type}
                                    description={v2?.description}
                                    isActivated={isActivated}
                                    isSwitchActivated={isSwitchActivated}
                                    onPress={() => {
                                        if (isActivated) {
                                            setItems([...items.filter(i => i.classificationCode !== c)])
                                        } else {
                                            setItems([...items, {
                                                classificationCode: c,
                                                commissionType: type,
                                                isQuick: false,
                                            }])
                                        }
                                    }}
                                    onPressSwitch={() => {
                                        setItems([
                                            ...items.filter(i => i.classificationCode !== c),
                                            {
                                                classificationCode: c,
                                                commissionType: type,
                                                isQuick: !isSwitchActivated,
                                            }
                                        ])
                                    }}
                                />
                            )
                        })}
                        <Col span={24}>
                            <Divider />
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 20, }}>
                        <Col span={24}>
                            <Typography.Text
                                strong
                                style={{
                                    fontSize: 20,
                                }}
                            >
                                {`위임 및 약관 동의`}
                            </Typography.Text>
                        </Col>
                        <Col span={24}>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Link
                                        onClick={() => {
                                            if (!출원인) {
                                                alert('출원인 정보를 입력하세요.')
                                                return
                                            }

                                            setShow결제동의Modal(true)
                                        }}
                                    >
                                        <Space>
                                            <img src={hasAgree ? Vector.check.blue : Vector.check.gray} alt='약관 동의 이미지' />
                                            <Typography.Text style={{ fontSize: 16, color: Color.Gray80 }}>
                                                {'위임 동의에 날인 또는 도장 이미지를 추가해주세요'}
                                            </Typography.Text>
                                        </Space>
                                    </Typography.Link>
                                </Col>
                                <Col>
                                    <Typography.Link
                                        style={{
                                            fontSize: 16,
                                            color: Color.Gray50,
                                        }}
                                        href={'/views/privacy-term'}
                                        target="_blank"
                                    >
                                        보기
                                    </Typography.Link>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24}>
                    <LayoutContainer style={{ gap: 10, }}>
                        <Col span={24}>
                            <Typography.Text
                                strong
                                style={{
                                    fontSize: 20,
                                }}
                            >
                                {`결제 금액`}
                            </Typography.Text>
                        </Col>
                        <Col span={24}>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Link
                                        onClick={() => {
                                            setShow환불정책Modal(true)
                                        }}
                                    >
                                        <Space>
                                            <Typography.Text style={{ fontSize: 18 }}>
                                                {'환불 정책'}
                                            </Typography.Text>
                                        </Space>
                                    </Typography.Link>
                                </Col>
                                <Col>
                                    <Typography.Link
                                        strong
                                        style={{
                                            fontSize: 18,
                                            color: Color.Gray50,
                                        }}
                                        onClick={() => {
                                            setShow환불정책Modal(true)
                                        }}
                                    >
                                        보기
                                    </Typography.Link>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Text
                                        style={{
                                            fontSize: 18,
                                            color: Color.Gray50,
                                        }}
                                    >
                                        {'VAT'}
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 18,
                                            color: Color.Gray50,
                                        }}
                                    >
                                        {`${NumberUtility.comma((수수료()) * 0.1)} 원`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 18,
                                            color: Color.Blue70,
                                        }}
                                    >
                                        {'총 결제 금액'}
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 18,
                                            color: Color.Blue70,
                                        }}
                                    >
                                        {`${NumberUtility.comma(Math.round(수수료() * 1.1))} 원`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 16,
                                        }}
                                    >
                                        {'※ 특허청 관납료'}
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 16,
                                        }}
                                    >
                                        {`${NumberUtility.comma(관납료())} 원`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row justify={'space-between'}>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 16,
                                        }}
                                    >
                                        {'※ 특허사무소 수수료 (VAT 별도)'}
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text
                                        strong
                                        style={{
                                            fontSize: 16,
                                        }}
                                    >
                                        {`${NumberUtility.comma(특허사무소수수료())} 원`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: 12, }}>
                                <Col span={24}>
                                    <Space direction='vertical' size={4} wrap>
                                        <Typography.Text style={{ fontSize: 16, }} type='secondary'>
                                            {`※ 특허청 관납료 ${NumberUtility.comma(관납료())}원은 별도 안내에 따라 추가로 납부 해주세요.`}
                                        </Typography.Text>
                                        <Typography.Text style={{ fontSize: 16, }} type='secondary'>
                                            {`※ 특허사무소 수수료 ${NumberUtility.comma(특허사무소수수료())}원은 별도 안내에 따라 추가로 납부 해주세요.`}
                                        </Typography.Text>
                                    </Space>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <Space direction='vertical' wrap>
                                <Typography.Text style={{ fontSize: 16, }}>
                                    {'1. 특허청 관납료는 특허청 고시 명칭/지정 상품 10개 기준으로 책정되며, 지정 상품이 10개를 초과하거나 비고시 상품명칭을 사용할 경우 추가 관납료가 발생합니다.'}
                                </Typography.Text>
                                <Typography.Text style={{ fontSize: 16, }}>
                                    {'2. 상품 출원 후 특허청 심사관으로부터 거절이유를 통지받을 경우, 이에 대응하는 의견서 및 보정서 제출 시 별도의 추가 비용이 발생할 수 있습니다.'}
                                </Typography.Text>
                                <Typography.Text style={{ fontSize: 16, }}>
                                    {'3. 상표가 성공적으로 등록 결정될 경우, 추가 비용(등록대리인 수수료 및 등록료)이 발생합니다.'}
                                </Typography.Text>
                            </Space>
                        </Col>
                        <Col span={24}>
                            <Alert
                                description={
                                    <Space direction='vertical' size={4}>
                                        <Typography.Text strong>
                                            {'꼭 확인해주세요!'}
                                        </Typography.Text>
                                        <Typography.Text strong>
                                            {'출원 요청을 완료한 경우, 추후 절차는 기재하여 주신 이메일로 안내될 예정입니다. 이메일을 확인하여 주시기 바랍니다.'}
                                        </Typography.Text>
                                    </Space>
                                }
                                type={'warning'}
                                showIcon
                                closable
                                icon={<ExclamationCircleOutlined className="text-xl" />}
                                style={{ borderRadius: '8px', padding: '8px', marginBlock: 12 }}
                            />
                        </Col>
                    </LayoutContainer>
                </Col>
                <Col span={24} style={{ marginTop: 60, }}>
                    <LayoutContainer style={{ justifyContent: 'center' }}>
                        <Col span={12}>
                            <Button
                                block
                                loading={isLoading}
                                className='primary'
                                onClick={() => {
                                    if (items.length <= 0) {
                                        message.error('결제할 아이템이 선택되지 않았습니다. 상퓸류를 하나 이상 선택해 주세요!')
                                        return
                                    }

                                    if (!hasAgree) {
                                        message.error('약관 동의를 진행해 주세요.')
                                        return
                                    }

                                    if (!담당자) {
                                        message.error('담당자 정보를 입력해 주세요.')
                                        return
                                    }

                                    if (!출원인) {
                                        message.error('출원인 정보를 입력해 주세요.')
                                        return
                                    }

                                    if (type === 출원방법타입.출원방법.바로출원) {
                                        if ((지정상품?.length ?? 0) <= 0) {
                                            message.error('지정상품을 1개 이상 추가해 주세요.')
                                            return
                                        }

                                        const missings: Array<string> = []
                                        const 지정상품codes = 지정상품?.map(s => s.classificationCode) ?? []
                                        items.forEach((s) => {
                                            if (!지정상품codes.includes(s.classificationCode)) {
                                                missings.push(`${s.classificationCode}류`)
                                            }
                                        })

                                        if (missings.length > 0) {
                                            message.error(`${missings.join(',')}에 대한 지정상품 정보를 추가해주세요`)
                                            return
                                        }
                                    }

                                    if (!image) {
                                        message.error('도장 이미지를 추가해 주세요.')
                                        return
                                    }

                                    handleOrder()
                                }}
                            >
                                {`${(items.length) > 0 ? `${NumberUtility.comma(Math.round(수수료() * 1.1))} 원 결제하기` : `상품류를 선택해 주세요`}`}
                            </Button>
                        </Col>
                    </LayoutContainer>
                </Col>
            </Row>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <결제동의Modal
                open={show결제동의Modal}
                출원인={출원인!}
                stamp={image}
                onClosed={() => {
                    setShow결제동의Modal(false)
                }}
                onPress={(image: ImageModel.IStampImageModel) => {
                    setHasAgree(true)
                    setShow결제동의Modal(false)
                    setImage(image)
                }}
            />
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <담당자정보입력Modal
                담당자={담당자}
                open={show담당자정보입력Modal}
                onPress={(담당자) => {
                    set담당자(담당자)
                    setShow담당자정보입력Modal(false)
                }}
                onClosed={() => {
                    setShow담당자정보입력Modal(false)
                }}
            />
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <추천코드정보입력Modal
                추천코드={추천코드}
                open={show추천코드정보입력Modal}
                onPress={(code) => {
                    set추천코드(code)
                    setShow추천코드정보입력Modal(false)
                }}
                onClosed={() => {
                    setShow추천코드정보입력Modal(false)
                }}
            />
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <출원자정보입력Modal
                담당자={담당자}
                출원인={출원인}
                open={show출원자정보입력Modal}
                onPress={(출원인) => {
                    set출원인(출원인)
                    setShow출원자정보입력Modal(false)
                }}
                onClosed={() => {
                    setShow출원자정보입력Modal(false)
                }}
            />
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <지정상품입력Modal
                open={show지정상품입력Modal}
                지정상품={지정상품}
                codes={codes ?? []}
                onPress={(지정상품: Array<TrademarkModel.ITrademarkModel지정상품Model>) => {
                    setShow지정상품입력Modal(false)
                    set지정상품(지정상품)
                }}
                onClosed={() => {
                    setShow지정상품입력Modal(false)
                }}
            />
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <환불정책Modal
                open={show환불정책Modal}
                onClosed={() => {
                    setShow환불정책Modal(false)
                }}
            />
        </Container>
    )
}